import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { BUSINESS } from "@/data/business";
import { SERVICES } from "@/data/services";

export const Footer = () => {
  return (
    <footer className="bg-tira-bgAlt border-t border-tira-accent/10 text-tira-text/90 pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="mt-5 text-sm leading-relaxed text-tira-textMuted max-w-xs">
              An earthy terracotta sanctuary in Kothapet for deep tissue,
              Thai, full body & aromatherapy massage rituals.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-tira-accent mb-4">
              Services
            </p>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={s.path}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-sm text-tira-textMuted hover:text-tira-accent transition-colors"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-tira-accent mb-4">
              Visit Us
            </p>
            <a
              href={BUSINESS.mapsDirectionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address-link"
              className="flex items-start gap-2.5 text-sm text-tira-textMuted hover:text-tira-accent transition-colors leading-relaxed"
            >
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-tira-jade" />
              {BUSINESS.address}
            </a>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-tira-accent mb-4">
              Call to Book
            </p>
            <a
              href={`tel:${BUSINESS.phoneClean}`}
              data-testid="footer-phone-link"
              className="flex items-center gap-2.5 font-heading text-lg text-tira-text hover:text-tira-accent transition-colors"
            >
              <Phone className="w-4 h-4 text-tira-jade" />
              {BUSINESS.phoneDisplay}
            </a>
            <Link
              to="/contact"
              data-testid="footer-contact-link"
              className="inline-block mt-4 text-sm text-tira-textMuted hover:text-tira-accent underline underline-offset-4"
            >
              Get Directions →
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-tira-accent/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-tira-textMuted/70">
          <p>© {new Date().getFullYear()} Tira Spa. All rights reserved.</p>
          <p>Kothapet, Hyderabad, Telangana 500035</p>
        </div>
      </div>
    </footer>
  );
};
